// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3DcdD","box":"WorkspacesBox_box__1Lton","node":"WorkspacesBox_node__pU18N"};